// import MyPageContent from "components/6_MyPage/6_2_myPage/MyPageContent"
import MypageContent from '@/features/mypage/components/MypageContent'
import LoginPage from '@/features/mypage/pages/LoginPage'
import useCookies from '@/shared/hooks/useCookies.hook'
// import { useRecoilValue } from "recoil"
// import { resLoginUser } from "../../recoil/user/atom"

const MypagePage = () => {
  const { getSessionCookie } = useCookies()
  // const login = useRecoilValue(resLoginUser)
  const session = getSessionCookie()
  // const user = useRecoilValue(resLoginUser)
  // console.log("session", session)
  if (!(session.PNumber !== '' && session.SessionID !== '')) {
    return <LoginPage />
  } else {
    return <MypageContent />
  }
}

export default MypagePage
